import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72bb8bfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auxbanner" }
const _hoisted_2 = { class: "moveUserView" }
const _hoisted_3 = {
  key: 0,
  class: "moveUser"
}
const _hoisted_4 = {
  key: 1,
  class: "moveUser"
}
const _hoisted_5 = { class: "moveFrom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Flytt fra: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "moveTo" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Flytt til firma:", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Flytt")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Avbryt")

import SearchAndSelect from '@/components/SearchAndSelectList/SearchAndSelect.vue';
import { onBeforeMount, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import APIServices from '@/services/apiFetch';
import { UserType } from '@/typings/User/user';
import { AuxButton, AuxBanner, AuxCard, AuxSpinner } from '@ambita/design-system';
import { RouterService } from '@/router';
import UserInfo from '@/components/Cards/UserCard/UserInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MoveUserCard',
  setup(__props) {

let user = ref<UserType.User>();
const route = useRoute();
let isLoading = ref<boolean>(true);

const newCompany = ref({
  name: '',
  id: 0,
});

const banner = reactive({
  type: '',
  message: '',
  showBanner: false,
});

onBeforeMount(async () => {
  user.value = await APIServices.fetchUserById(route.params.guid);
  isLoading.value = false;
});

const setCompany = function (id, name) {
  newCompany.value.name = name;
  newCompany.value.id = id;
};

const moveUser = async function (guid, newCompany, username) {
  const text = `Er du sikker på at du vil flytte bruker: ${username}?`;
  if (newCompany) {
    if (confirm(text)) {
      let user = await APIServices.putUser(guid, newCompany);
      banner.message = await user.json();
      user.status === 200 ? (banner.type = 'success') : (banner.type = 'error');
      banner.showBanner = true;
    }
  } else {
    alert('Du må velge en firma');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AuxBanner), {
        type: banner.type
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(banner.message), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ], 512), [
      [_vShow, banner.showBanner]
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_unref(AuxSpinner), {
          key: 0,
          class: "spinner"
        }))
      : (_openBlock(), _createBlock(_unref(AuxCard), {
          key: 1,
          class: "userCardContent"
        }, {
          default: _withCtx(() => [
            _createVNode(UserInfo, { user: _unref(user) }, null, 8, ["user"]),
            _createElementVNode("div", _hoisted_2, [
              (_unref(user)?.tasks?.length > 0)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Flytt bruker med alle prosjekter"))
                : (_openBlock(), _createElementBlock("h2", _hoisted_4, "Flytt bruker")),
              _createElementVNode("p", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_unref(user)?.company?.name), 1)
              ]),
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(newCompany.value?.name), 1)
              ]),
              _createVNode(SearchAndSelect, { onSetCompany: setCompany }),
              _createElementVNode("div", null, [
                _createVNode(_unref(AuxButton), {
                  primary: true,
                  size: "small",
                  class: "btn",
                  disabled: !newCompany.value.id,
                  onClick: _cache[0] || (_cache[0] = () => moveUser(_unref(user)?.guid, newCompany.value?.id, _unref(user)?.username))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(AuxButton), {
                  primary: false,
                  size: "small",
                  class: "btn",
                  onClick: _cache[1] || (_cache[1] = () => _unref(RouterService).routeBack())
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
  ], 64))
}
}

})